import {debounce} from '@helpers/utils'
import {Component} from 'lowkey-component'

import type {IField} from './BaseFormField'
import {BaseFormField} from './BaseFormField'

export class FormFileField extends BaseFormField<File | undefined> implements IField<File | undefined> {
  private filename: HTMLParagraphElement | null = null
  private input: Component<HTMLInputElement> | null = null

  didMount() {
    super.didMount()
    this.filename = this.element.querySelector('.a-file_name .a-body') as HTMLParagraphElement
    this.input = new Component<HTMLInputElement>(
      (this.element?.querySelector('input[type=file]') as HTMLInputElement)
    )
    this.input.mount()
    this.input.on('blur', this.onBlur.bind(this))
    this.input.on('change', this.onChange.bind(this))
    this.input.on('keyup', debounce(this.onChange.bind(this), 200))
  }

  onChange() {
    super.onChange()
    if (this.input) {
      const [file] = this.input.element.files || []
      if (file) {
        this.filename && (this.filename.style.opacity = '1')
        this.filename && (this.filename.textContent = file.name)
      } else {
        this.filename && (this.filename.style.opacity = '0.3')
        this.filename && (this.filename.textContent = 'ファイル名.PDF')
      }
    }
  }

  set readonly(val: boolean) {
    if (val) {
      this.input?.element?.setAttribute('disabled', 'disabled')
    } else {
      this.input?.element?.removeAttribute('disabled')
    }
  }

  get value(): File | undefined {
    if (this.input?.element.files) {
      return this.input?.element?.files[0]
    }
    return undefined
  }

  get name() {
    return this.input?.element?.getAttribute('name') || ''
  }
}
